import { useCallback } from 'react';
import { api } from 'src/constants/apiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

export interface MergeAttachmentRequest {
  attachmentId: number;
  invoiceId: number;
  companyId: number;
}

const useMergeAttachmentApi = () => {
  const call = useCallback(async (body?: MergeAttachmentRequest) => {
    try {
      const res = await axiosInstance.post(api.mergeAttachment(), body);
      return res.data;
    } catch (error) {
      throw new Error(error);
    }
  }, []);

  const { isLoading, execute } = useAsync(call, false);

  return {
    mergeAttachment: execute,
    isMergeAttachmentLoading: isLoading,
  };
};

export default useMergeAttachmentApi;
